import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, SESSION_TIMEOUT_REDIRECT_KEY, LOGOUT_INTERACTION_LOST_KEY } from 'src/app/services/auth/auth.service';
import { RoleService } from 'src/app/services/role/role.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LandingComponent implements OnInit {

  loaded = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private roleService: RoleService,
    private spinnerService: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.spinnerService.show();
    if (localStorage.getItem(SESSION_TIMEOUT_REDIRECT_KEY)) {
      localStorage.removeItem(SESSION_TIMEOUT_REDIRECT_KEY);
      this.spinnerService.hide();
      this.router.navigate(['/session-expired']);
      return;
    }
    if (localStorage.getItem(LOGOUT_INTERACTION_LOST_KEY)) {
      localStorage.removeItem(LOGOUT_INTERACTION_LOST_KEY);
      this.spinnerService.hide();
      this.router.navigate(['/session-expired']);
      return;
    }
    if (this.authService.isCheckLogin()) {
      const auditRoles = ['isUserAuditorGRID', 'isUserAuditorLevel1', 'isUserAuditorLevel2', 'isUserAuditorLevel3'];
      this.spinnerService.hide();
      if (this.roleService.hasUserAccess(auditRoles)) {
        this.router.navigate(['/user-audit'], { replaceUrl: true });
      } else {
        this.router.navigate(['/machine'], { replaceUrl: true });
      }
    } else {
      this.loaded = true;
      this.spinnerService.hide();
      this.cdr.markForCheck();
    }
  }
}
